// extracted by mini-css-extract-plugin
export default {"gameNotFoundMain":"GroupGameNotFound_gameNotFoundMain__X4zLJ"};